import React from 'react';
import { AdminPanelSettingsOutlined, ArrowRightAlt, CalendarMonthOutlined, ExitToApp, Groups2Outlined, HomeOutlined, LockOpen, Logout, ManageAccounts, MeetingRoom, Person, PieChartOutlined, PowerSettingsNew, PublicOutlined, ReceiptLong, TodayOutlined, WorkspacePremium, } from "@mui/icons-material";
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import VideoFileOutlinedIcon from '@mui/icons-material/VideoFileOutlined';
import GroupIcon from '@mui/icons-material/Group'
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';

export const userNavItems = [
  {
    text: "Dashboard",
    path: "dashboard",
    icon: <HomeOutlined />,
    bold: true,
  },

  {
    text: "Consolidated Data",
    icon: null,
  },

  {
    text: "Customer Data",
    path: "parsedcustomerdata",  
    icon: <StorageOutlinedIcon />,
  },
  {
    text: "Customer Faults",
    path: "parsedlogs",
    icon: <Groups2Outlined />,
  },

  {
    text: "Reports",
    path: "reports",
    icon: <ManageSearchOutlinedIcon />,
  },
  {
    text: "Invoice Stats",
    icon: null,
  },
  {
    text: "Daily",
    path: "daily",
    icon: <TodayOutlined />,
  },
  {
    text: "Monthly",
    path: "monthly",
    icon: <CalendarMonthOutlined />,
  },
  {
    text: "Yearly",
    path: "yearly",
    icon: <ManageSearchOutlinedIcon />,
  },

  {
    text: "Invoice Overview",
    icon: null,
  },
  {
    text: "Invoices",
    path: "invoices",
    icon: <VideoFileOutlinedIcon />,
  },
  {
    text: "Breakdown",
    path: "invoices/breakdown",
    icon: <PieChartOutlined />,
  },
  {
    text: "Geography",
    path: "invoices/geography",
    icon: <PublicOutlined />,
  },
  {
    text: "My Profile",
    path: "Updateprofile",
    icon: <Person />,
  },
  {
    text: "Logout",
    action: "logout",   // ← special action flag, no path
    icon: <Logout />,
  },
];

export const superAdminNavItems = [
  {
    text: "Data Operations",
    icon: null,
  },
  {
    text: "Load Data from SQL Server",
    path: "admin/sql-data-migration",
    icon: <StorageOutlinedIcon />,
  },
  {
    text: "User Management",
    icon: null,
  },
  {
    text: "Create User",
    path: "createuser",
    icon: <GroupAddIcon />,
  },
  {
    text: "Admin",
    path: "admin",
    icon: <AdminPanelSettingsOutlined />,
  },
  {
    text: "Team",
    path: "team",
    icon: <GroupIcon />,
  },
  {
    text: "Customers",
    path: "customers",
    icon: <Groups2Outlined />,
  },
];

export const adminNavItems = [
  {
    text: "Dashboard",
    path: "dashboard",
    icon: <HomeOutlined />,
    bold: true,
  },
  {
    text: "Consolidated Data",
    icon: null,
  },
  {
    text: "Customer Data",
    path: "parsedcustomerdata",   
    icon: <StorageOutlinedIcon />,
  },
  {
    text: "Customer Faults",
    path: "parsedlogs",
    icon: <Groups2Outlined />,
  },

  {
    text: "Reports",
    path: "reports",
    icon: <ManageSearchOutlinedIcon />,
  },
  {
    text: "Invoice Stats",
    icon: null,
  },
  {
    text: "Daily",
    path: "daily",
    icon: <TodayOutlined />,
  },
  {
    text: "Monthly",
    path: "monthly",
    icon: <CalendarMonthOutlined />,
  },
  {
    text: "Yearly",
    path: "yearly",
    icon: <ManageSearchOutlinedIcon />,
  },

  {
    text: "Invoice Overview",
    icon: null,
  },
  {
    text: "Invoices",
    path: "invoices",
    icon: <VideoFileOutlinedIcon />,
  },
  {
    text: "Breakdown",
    path: "invoices/breakdown",    
    icon: <PieChartOutlined />,
  },
  {
    text: "Geography",
    path: "invoices/geography",
    icon: <PublicOutlined />,
  },
  {
    text: "Customer Overview",
    icon: null,
  },
  {
    text: "Customers",
    path: "customers",
    icon: <Groups2Outlined />,
  },
  {
    text: "Breakdown",
    path: "customers/breakdown", 
    icon: <PieChartOutlined />,
  },
  {
    text: "Geography",
    path: "customers/geography", 
    icon: <PublicOutlined />,
  },

  {
    text: "App Settings",
    icon: null,
  },
  {
    text: "User Management",
    icon: null,
  },
  {
    text: "Users",
    path: "team",
    icon: <GroupIcon />,
  },
  {
    text: "Create User",
    path: "createuser",
    icon: <GroupAddIcon />,
  },
  {
    text: "Billing & Subscriptions",
    icon: null,
  },
  {
    text: "Current Plan",
    path: "billing/current-plan",
    icon: <WorkspacePremium />,
  },
  {
    text: "Manage Subscription",
    path: "billing/manage-subscription",
    icon: <ManageAccounts />,
  },
  {
    text: "Payment History",
    path: "billing/payment-history",
    icon: <ReceiptLong />,
  },
  {
    text: "Account Settings",
    icon: null,
  },
  {
    text: "My Profile",
    path: "Updateprofile",
    icon: <Person />,
  },
  {
    text: "Logout",
    action: "logout",   
    icon: <Logout />,
  },
];
